import { API } from 'aws-amplify';
import { fetchSyncFhir } from '../../common/graphql/queries';
import { Medication } from './query';


export const PATIENT = "patient";
export const MAR = "mar";
export const ENCOUNTERS = "encounters";
export const REASONS_FOR_VISIT = "reasons_for_visit";
export const ACTIVE_CSN_BY_PATIENT_FHIR_ID = "active_csn_by_patient_fhir_id";

export interface FetchFhirPatientInput {
    mrn: string,
}

export interface FetchFhirMedicationsInput {
    csn: string,
    mrn: string,
    external_id: string,
}

export interface FetchFhirEncountersInput {
    fhir_id: string,
    from_date: string,
    to_date: string,
}

export interface FetchFhirReasonsForVisitInput {
    fhir_id: string,
    csn: string,
}

export interface FetchFhirActiveCsnForPatientFhirID {
    fhir_id: string,
}

export interface FhirPatientVisit {
    mrn: string,
    family: string | null,
    given: string | null,
    email: string | null,
    phone_home: string | null,
    phone_mobile: string | null,
    languages: string[] | null,
}


export const callFhirMedications = async (input: FetchFhirMedicationsInput): Promise<Medication[]> => {
    try {
        const response: any = await API.graphql({
            query: fetchSyncFhir,
            variables: {
                input: JSON.stringify({
                    ...input,
                    operation: MAR,
                }),
            }
        });
        console.log('callFetchSyncFhir response', response);
        return JSON.parse(response["data"]["fetchSyncFhir"]);
    } catch (err: any) {
        console.error("An error occurred while fetching medications", err);
        return [];
    }
}

export const callFhirPatient = async (input: FetchFhirPatientInput): Promise<FhirPatientVisit> => {
    try {
        const response: any = await API.graphql({
            query: fetchSyncFhir,
            variables: {
                input: JSON.stringify({
                    ...input,
                    operation: PATIENT,
                }),
            }
        });
        return JSON.parse(response["data"]["fetchSyncFhir"]);
    } catch (err: any) {
        console.error("An error occurred while fetching patients", err);
        return {
            mrn: input.mrn,
            family: "",
            given: "",
            email: "",
            phone_mobile: "",
            phone_home: "",
            languages: [],
        };
    }
}

export const callFhirEncounters = async (input: FetchFhirEncountersInput): Promise<any> => {
    try {
        const response: any = await API.graphql({
            query: fetchSyncFhir,
            variables: {
                input: JSON.stringify({
                    ...input,
                    operation: ENCOUNTERS,
                }),
            }
        });
        return JSON.parse(response["data"]["fetchSyncFhir"]);
    } catch (err: any) {
        console.error("An error occurred while fetching patients", err);
        return [];
    }
}

export const callFhirReasonsForVisit = async (input: FetchFhirReasonsForVisitInput): Promise<any> => {
    try {
        const response: any = await API.graphql({
            query: fetchSyncFhir,
            variables: {
                input: JSON.stringify({
                    ...input,
                    operation: REASONS_FOR_VISIT,
                }),
            }
        });
        return JSON.parse(response["data"]["fetchSyncFhir"]);
    } catch (err: any) {
        console.error("An error occurred while fetching patients", err);
        return [];
    }
}

export const callFhirActiveCsnByPatientFhirID = async (input: FetchFhirActiveCsnForPatientFhirID): Promise<any> => {
    try {
        const response: any = await API.graphql({
            query: fetchSyncFhir,
            variables: {
                input: JSON.stringify({
                    ...input,
                    operation: ACTIVE_CSN_BY_PATIENT_FHIR_ID,
                }),
            }
        });
        return JSON.parse(response["data"]["fetchSyncFhir"]);
    } catch (err: any) {
        console.error("An error occurred while fetching patients", err);
        return "";
    }
}
